import React, {  Component } from 'react';

export default class LineStatusDescriptionsOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('LineStatusDescriptionsOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
				<a className="closeButton fontSize-10" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">{this.props.isPNETOrNCRP ? 'Parts Line Status Descriptions' : 'Line Status Descriptions'}</h2>
                    <div className="scroll-height-action-description">
    					<table className="dataTable actionDescriptionsTable">
    						<thead>
    							<tr>
    								<th>Status Name</th>
    								<th>Status Description</th>
    							</tr>
    						</thead>
    						{this.props.isPNETOrNCRP ? <tbody>
								<tr>
    								<td>Entered</td>
    								<td>Order has been created and requires booking to be processed</td>
    							</tr>
								<tr>
    								<td>Booked</td>
    								<td>Pricing has been captured and the item(s) have a place in line for processing</td>
    							</tr>
								<tr>
    								<td>Awaiting Shipping</td>
    								<td>Items have not downloaded to the warehouse. Orders are waiting to be consolidated or processed</td>
    							</tr>
								<tr>
    								<td>Picked</td>
    								<td>Order has availability and has been downloaded to the warehouse to prepare for shipping. These lines are past the point of no return and can not be cancelled</td>
    							</tr>
								<tr>
    								<td>Backordered</td>
    								<td>Item is not currently available. A date will be given with an estimated fulfillment date</td>
    							</tr>
								<tr>
    								<td>Shipped</td>
    								<td>Order has left the warehouse and is in transit. A tracking number is provided. These lines are past the point of no return and can not be cancelled</td>
    							</tr>
							</tbody> : <tbody>
    							<tr>
    								<td>Entered</td>
    								<td>Line has been saved and no action will be taken until order is booked</td>
    							</tr>
                                <tr>
    								<td>Booked</td>
    								<td>Pricing has been captured and the item(s) have a place in line for reservation</td>
    							</tr>
                                <tr>
    								<td>Awaiting Shipping</td>
    								<td>This status will show while the order captures reservations, until it leaves the ADC</td>
    							</tr>
								<tr>
    								<td>Shipped</td>
    								<td>Product has shipped from the ADC to the SDS</td>
    							</tr>
                                <tr>
    								<td>Arrived at SDS</td>
    								<td>Product has arrived at SDS facility for pickup or delivery to customer</td>
    							</tr>
								<tr>
    								<td>Ready for Pickup</td>
    								<td>ADC Will Call order is ready for pickup</td>
    							</tr>
                                <tr>
    								<td>Closed (SDS)</td>
    								<td>Product has been picked up or delivered to customer and can now be invoiced</td>
    							</tr>
                                <tr>
    								<td>Closed (ADC)</td>
    								<td>Product shipped from the ADC and can invoice</td>
    							</tr>
                                <tr>
    								<td>Backorder Hold</td>
    								<td>Your order has been received and is waiting for product to become available.When it becomes available, you will be notified and will need to manage it to a new order</td>
    							</tr>
                                <tr>
    								<td>Backorder Available</td>
    								<td>Your ordered product has become available and must be booked on a new order to capture reservation. Available backorders will expire after 7 days of becoming available</td>
    							</tr>
    						</tbody>}
    					</table>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/lineStatusDescriptionsOverlayDialog.js